module.exports = __webpack_public_path__ + "img/yn_yu.73be19cb.png";